export default __webpack_public_path__ + "static/1-e737e0936528752f831d255c88c26f79.jpg";